import actions from './actions';
import initialState from '../initialState';

export const adminUsersReducer = (state = initialState.adminUsers, action) => {
    switch (action.type) {
        case actions.ADMIN_USER_MODAL:
            return { ...state, adminUserModal: action.state.adminUserModal };
        case actions.ADMIN_ROLES_MODAL:
            return { ...state, adminRolesModal: action.state.adminRolesModal };
        default:
            return { ...state };
    }
};

export default adminUsersReducer;
